import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
    validaSoloNumero} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CatalogoDepartamento from '../../catalogos/catalogoDepartamento';
import moment from 'moment';

export const GestionarDepartamento = (props) => {

    var op = require('../../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');
    const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'))

  
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnSalir = useRef();
    const txtIdDepartamento = useRef();
    const txtDescripcion = useRef();
    const [tituloHeader, setTituloHeader] = useState('Gestion Departamento.')

    const [visibleBtn, setVisibleBtn] = useState('visible')
    const [body, setBody] = useState(null);
    const [activate, setActivate] = useState(false);
    const [habilitado, setHabilitado] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [catalogoDepartamento, setCatalogoDepartamento] = useState(false);
    const [botones, setBotones] = useState({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      salir: false
    });
  
    const onChange = (e) => {
  
      if (e.target.name === 'descripcion') {
        e.target.value = e.target.value;
      }else{
        e.target.value = e.target.value;
      }
    }
  
    const seleccionarRegistro = () => {
      let campos = 'iddepartamento, trim(descripcion) as descripcion';
      let nomtab = 'departamento';
      let nomid = 'iddepartamento';
      let id = txtIdDepartamento.current.value;
      let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
  
      setActivate(true);
      axios.get(endpoint, {
        headers: {
          'x-access-token': `${token}`
        }
      }).then(function (response) {
        if (response.status === 200) {
  
          txtDescripcion.current.value = '';
  
          if (response.data !== '') {
  
            txtDescripcion.current.value = response.data.descripcion.trim();

          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un departamento con este codigo', icono: 'informacion' });
            txtDescripcion.current.value = '';
          }
        }
        setActivate(false);
      }).catch(function (error) {
        setActivate(false);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      })
    };
  
    const validarDepartamento = (event) => {
      event.preventDefault();
      validaSoloNumero(event);
      if (event.which === 13 || typeof (event.which) === 'undefined') {
        if (event.target.value !== '') {
  
          seleccionarRegistro();
  
        }
      }
    };
  
    const onCatalogoDepartamento = (values) => {
      setCatalogoDepartamento(false);
      txtIdDepartamento.current.value = values.iddepartamento;
      txtDescripcion.current.value = values.descripcion;
    }
  
    const onChangeValidar = () => {
  
      let sigue = true;
      if (!botones.incluir || !botones.modificar) {
  
        if (txtDescripcion.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
          txtDescripcion.current.focus()
          sigue = false
        } 
      }
  
      if (sigue) {
  
        var departamento = [];
        departamento.push({
          iddepartamento: txtIdDepartamento.current.value === '' ? 0 : txtIdDepartamento.current.value,
          descripcion: txtDescripcion.current.value.toUpperCase().trim(),
        })
  
        setBody({
            departamento: departamento
        });
  
  
        let msg = '';
        if (!botones.incluir) {
          msg = 'Esta Seguro de Registrar estos Datos.';
        } else if (!botones.modificar) {
          msg = 'Esta Seguro de Modificar estos Datos.';
        } else if (!botones.eliminar) {
          msg = 'Esta Seguro de Eliminar estos Datos.';
        }
  
        setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
      }
    }
  
    const procesarRegistro = () => {
      setActivate(true);
      let ope = 0;
      if (!botones.incluir) {
        ope = 1;
      } else if (!botones.modificar) {
        ope = 2;
      } else if (!botones.eliminar) {
        ope = 3;
      }
      let endpoint = `${op.conexion}/api/departamento/actualizar/${ope}`;
      axios.post(endpoint, body, {
        headers: {
          'x-access-token': `${token}`
        }
      }).then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
          } else if (ope === 2) {
            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
          } else if (ope === 3) {
            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
          }
          setActivate(false);
        }
      }).catch(function (error) {
        let mensaje = '';
        if (error.response === undefined) {
          mensaje = 'Error de Conexion'
        } else {
          if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
            mensaje = 'Ya existe un Registro con este rif'
  
          } 
          else {
            mensaje = error.response.data.message
          }
        }
        setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        setActivate(false);
      })
    };

  
    const blanquear = () => {
      setTituloHeader('Gestionar Departamento.')
      setActivate(false);
      setBody(null);
      setHabilitado(true);
      setBotones({
        incluir: false,
        consultar: false,
        modificar: false,
        eliminar: false,
        aceptar: true,
        cancelar: true,
        catalogo: true,
        salir: false
      });
      txtIdDepartamento.current.setAttribute("disabled", true);
      txtIdDepartamento.current.value = '';
      txtDescripcion.current.value = '';
      setVisibleBtn('visible')
    
    }
  
    const cancelar = () => {
      blanquear();
      props.onHideCancela();
  
    };

    const handleCloseSi = () => {
      setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
      procesarRegistro();
    };
  
    const onBotones = (op) => (e) => {
      if(op === 1 || op === 2 || op === 3 || op === 4){
        setVisibleBtn('collapse')
      } else if (op === 6){
        setVisibleBtn('visible')
      }
  
      e.preventDefault();
  
      if (op === 1) {
        setTituloHeader('Incluir Departamento.')
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          salir: true
        });
        txtIdDepartamento.current.setAttribute("disabled", true);
        setTimeout(() => txtDescripcion.current.focus(), 200);
  
      } else if (op === 2) {
        setTituloHeader('Editar Departamento.')
        txtIdDepartamento.current.removeAttribute("disabled");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdDepartamento.current.focus();
  
      } else if (op === 3) {
        setTituloHeader('Eliminar Departamento.')
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdDepartamento.current.removeAttribute("disabled")
        txtIdDepartamento.current.focus();
      } else if (op === 4) {
        setTituloHeader('Consultar Departamento.')
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdDepartamento.current.removeAttribute("disabled")
        txtIdDepartamento.current.focus();
      } else if (op === 5) {
        onChangeValidar();
      } else if (op === 6) {
        blanquear();
      } else if (op === 7) {
        cancelar();
      }
    }

    const cerrarModal = () => {
      
      if (props.llamado===2) {
        props.onHideRenderizar();
        props.onHideCancela();
      }

        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    const imprimirDepartamentos = () => {
    
      window.open(op.reportes + "reporte=listDepartamento","Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");


  }
  

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {

            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <Modal.Title style={{ color: "#fff" }}>{tituloHeader} </Modal.Title>
               {/*  <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button> */}
                    <a href='#' ref={btnSalir} disabled={botones.salir} onClick={onBotones(7)} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF" }}>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>cargando...</Loader>
                </Dimmer>
                <div className='col-md-12 row mx-auto px-0'>
                <div className='col-md-12 mx-auto d-flex justify-content-end'>
                    <div className="mb-3 col-md-4"> 
                        <span >Fecha: <span className='fw-bold'>{moment(fechasistema).format('DD-MM-YYYY')} </span></span>
                    </div>
                  </div>
                    <div className='border-azul col-md-12 py-3 rounded mx-1'>
                      
                            <div className="row col-md-12 rounded mx-auto">
                                <div className="input-group input-group-sm mb-3 col-md-4">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                    <input type="text" ref={txtIdDepartamento} disabled onKeyUp={validarDepartamento} onBlur={validarDepartamento} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                    <button disabled={botones.catalogo} type="button" onClick={() => setCatalogoDepartamento(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
                                </div>
                                <div className="input-group input-group-sm mb-3 col-md-12">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                                    <input type="text" ref={txtDescripcion} name='descripcion'  autoComplete='off' disabled={habilitado} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={onChange} />
                                </div>
                                <div className="input-group input-group-sm  col-md-12 d-flex justify-content-end">
                                    <button  className="btn btn-primary btn-sm rounded " onClick={imprimirDepartamentos} ><i className="fas fa-print" ></i></button>
                                </div>
                            </div>

                    
                    </div>
                  
                </div>
            </Modal.Body >
            <Modal.Footer>
              <div className="col-md-12 mx-auto">

              {visibleBtn === 'visible' ? 
              
              <div className='col-md-12 mx-auto row justify-content-between' style={{visibility: props.llamado === 2 ? 'collapse': props.llamado !== 2 ? visibleBtn : 'visible'}}>
              <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 my-1 col btn-primary rounded-pill" style={{ height: '27px'}} title='Incluir Departamento'><i style={{ fontSize: '9px' }} className="fas fa-plus"> Incluir </i> </button>
              <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 my-1 col btn-info rounded-pill" style={{ height: '27px' }} title='Consultar Departamento' ><i style={{ fontSize: '9px' }} className="fas fa-eye">Consultar</i> </button>
              <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 my-1 col btn-warning rounded-pill" style={{ height: '27px' }} title='Modificar Departamento'><i style={{ fontSize: '9px' }} className="fa fa-edit">Modificar</i> </button>
              <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 my-1 col btn-danger rounded-pill" style={{ height: '27px' }} title='Eliminar Departamento'><i style={{ fontSize: '9px' }} className="fa fa-trash">Eliminar</i> </button>
            </div>
            
          : 
          
          <div className='col-md-12 row mx-auto justify-content-end' style={{visibility:visibleBtn === 'visible' ? 'collapse' : 'visible'}} >
          <button ref={btnAcepta}  disabled={botones.aceptar} onClick={onBotones(5)}  style={{ height: '27px' }} className="btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success "><i className="fas fa-check-circle" style={{ fontSize: '9px' }}>  Aceptar</i></button>
          <button ref={btnCancela} disabled={botones.cancelar} onClick={onBotones(6)}  style={{ height: '27px' }} className="btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill "><i className="fas fa-window-close" style={{ fontSize: '9px' }}> Cancelar</i></button>
      </div> }

                
          
              </div>
                   
                          </Modal.Footer>
            <CatalogoDepartamento
                show={catalogoDepartamento}
                onHideCancelar={() => setCatalogoDepartamento(false)}
                onHideAceptaCatalogo={onCatalogoDepartamento}
            />
        </Modal >
    );
}




// WEBPACK FOOTER //
// ./src/components/almacen/gestionarDepartamento.js